import msLogo from './microsoft-logo.svg';
import useSso from './sso.controller';

const ID = 'sso';
export interface SsoProps {
    callback?: () => void;
}

const Sso = (props: SsoProps) => {
    const viewProps = useSso(props);

    if (!viewProps.provider || !viewProps.url) {
        return <></>;
    }

    switch (viewProps.provider.type) {
        case 'microsoft':
            return (
                <a
                    className='flex h-[41px] flex-row items-center justify-start border-[1px] border-[#8C8C8C] bg-[#FFFFFF] text-[#5E5E5E] hover:border-[#2F2F2F] hover:bg-[#2F2F2F] hover:text-[#FFFFFF]'
                    href={viewProps.url}
                    onClick={viewProps.setRedirect}
                    id={ID}>
                    <img
                        src={msLogo}
                        className='px-[12px]'
                        alt='Microsoft'
                    />
                    <span className='pe-[12px] font-[15px]'>Sign in with Microsoft</span>
                </a>
            );
    }

    return (
        <a
            className='btn btn-primary'
            href={viewProps.url}
            onClick={viewProps.setRedirect}
            target='_blank'
            rel='noreferrer'
            id={ID}>
            {viewProps.provider.type}
        </a>
    );
};

export default Sso;
